const PROJECT_BUNDLE_FORMAT = 'databygger-project-bundle';
const PROJECT_BUNDLE_VERSION = 1;
const PROJECT_BUNDLE_EXTENSION = '.databygger';

const toArrayBuffer = projectData => {
    if (projectData instanceof ArrayBuffer) {
        return projectData;
    }

    if (ArrayBuffer.isView(projectData)) {
        return projectData.buffer.slice(
            projectData.byteOffset,
            projectData.byteOffset + projectData.byteLength
        );
    }

    if (projectData && typeof projectData.arrayBuffer === 'function') {
        return projectData.arrayBuffer();
    }

    throw new Error('Projektdata kunne ikke konverteres til et gembart format.');
};

const arrayBufferToBase64 = arrayBuffer => {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    const chunkSize = 0x8000;

    for (let index = 0; index < bytes.length; index += chunkSize) {
        const chunk = bytes.subarray(index, index + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
    }

    return btoa(binary);
};

const base64ToArrayBuffer = base64 => {
    const binary = atob(base64);
    const length = binary.length;
    const bytes = new Uint8Array(length);

    for (let index = 0; index < length; index++) {
        bytes[index] = binary.charCodeAt(index);
    }

    return bytes.buffer;
};

const createProjectBundle = async ({projectTitle, projectData, visionTrainingData}) => {
    const arrayBuffer = await toArrayBuffer(projectData);

    return JSON.stringify({
        format: PROJECT_BUNDLE_FORMAT,
        version: PROJECT_BUNDLE_VERSION,
        savedAt: new Date().toISOString(),
        projectTitle,
        projectData: arrayBufferToBase64(arrayBuffer),
        visionTrainingData
    });
};

const parseProjectBundle = text => {
    const parsed = JSON.parse(text);

    if (!parsed || parsed.format !== PROJECT_BUNDLE_FORMAT) {
        throw new Error('Filen er ikke en gyldig Databygger-projektpakke.');
    }

    if (!parsed.projectData) {
        throw new Error('Projektpakken mangler projektdata.');
    }

    return {
        projectTitle: parsed.projectTitle || '',
        projectData: base64ToArrayBuffer(parsed.projectData),
        savedAt: parsed.savedAt || '',
        version: parsed.version || 0,
        visionTrainingData: parsed.visionTrainingData || null
    };
};

const isProjectBundleFile = filename => {
    const normalized = String(filename || '').toLowerCase();
    return normalized.endsWith(PROJECT_BUNDLE_EXTENSION) || normalized.endsWith('.databygger.json');
};

export {
    PROJECT_BUNDLE_EXTENSION,
    PROJECT_BUNDLE_FORMAT,
    PROJECT_BUNDLE_VERSION,
    createProjectBundle,
    isProjectBundleFile,
    parseProjectBundle
};
